import { UAParser } from 'my-ua-parser';

const uaParser = new UAParser();

const device = uaParser.getDevice();

export const isMobile = () => device.type === 'mobile';
export const isTablet = () => device.type === 'tablet';
export const isComputer = () => device.type === undefined;
